import React from 'react';

const labelList = [
  {
    id: 211,
    name: 'Crema',
    alias: 'crema',
    color: '#dc3545',
    // icon: <WorkIcon />,
  },
  {
    id: 212,
    name: 'Personal',
    alias: 'personal',
    color: '#0d6efd',
    // icon: <PersonIcon />,
  },
  {
    id: 213,
    name: 'Work',
    alias: 'work',
    color: '#198754',
    // icon: <WorkIcon />,
  },
  {
    id: 214,
    name: 'Paypal',
    alias: 'paypal',
    color: 'grey',
    // icon: <WorkIcon />,
  },
];
export default labelList;
